import React from "react";
import { ProfileContactInfoComponent } from "../../../services/types/ComponentTypes";
// import { Phone, Mail, MapPin, Hash } from "lucide-react"; // Removed missing dependency

interface ProfileContactInfoProps {
    component: ProfileContactInfoComponent;
    formData: any;
}

const ProfileContactInfo: React.FC<ProfileContactInfoProps> = ({
    component,
    formData,
}) => {
    const getIcon = (name: string) => {
        // Simple text fallback for icons
        switch (name) {
            case "contact_email":
                return <span>📧</span>;
            case "contact_phone":
                return <span>📞</span>;
            case "contact_location":
                return <span>📍</span>;
            case "contact_emp_code":
                return <span>#</span>;
            default:
                return null;
        }
    };

    // Cast style to any to bypass type mismatch
    const containerStyle = { ...component.style, display: "flex", gap: 24, flexWrap: "wrap" } as any;

    return (
        <div style={containerStyle}>
            {component.fields?.map((field: any, index: number) => {
                const value = formData[field.BindValue];
                return (
                    <div key={index} style={{ display: "flex", alignItems: "center", gap: 8, color: "#666" }}>
                        {getIcon(field.name)}
                        <span style={{ fontSize: 14 }}>{value || "-"}</span>
                    </div>
                );
            })}
        </div>
    );
};

export default ProfileContactInfo;
